import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material';

function PostLabel({ postLabel }) {
    if (!postLabel) {
        return null;
    }
    return jsx(PostLabelWrapper, { children: postLabel });
}
const PostLabelWrapper = styled("div")(({ theme }) => ({
    marginLeft: theme.spacing(1.5),
    display: "flex",
}));

export { PostLabel };
//# sourceMappingURL=PostLabel.js.map
